export default {
  breadcrumbHome: '首页',
  author: '作者',
  publishDate: '发布时间',
  views: '阅读量',
  tags: '标签',
  shareArticle: '分享文章',
  relatedArticles: '相关推荐',
  prevArticle: '上一篇',
  nextArticle: '下一篇',
  backToList: '返回列表',
}